(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azlyf-bespoke-studio"] && !Shopify.designMode) return;
  try {
    
  class AzlyfBespokeStudio extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.canvas = this.querySelector('[data-canvas]');
      this.context = this.canvas.getContext('2d');
      this.objectLayer = this.querySelector('[data-object-layer]');
      this.upload = this.querySelector('[data-upload]');
      this.canvasFile = this.querySelector('[data-canvas-file]');
      this.method = this.querySelector('[data-method]');
      this.error = this.querySelector('[data-error]');
      this.history = [];
      this.future = [];
      this.drawing = false;
      this.hasArtwork = false;
      this.background = '#f3eee7';
      this.brush = 'pen';
      this.tool = 'freehand';
      this.symmetry = false;
      this.shapeStart = null;
      this.shapeSnapshot = null;
      this.selectedObject = null;
      this.resetCanvas();
      this.bindModes();
      this.bindUpload();
      this.bindCanvas();
      this.bindTools();
      this.querySelector('form').addEventListener('submit', (event) => this.prepareOrder(event));
      this.addEventListener('keydown', (event) => {
        if ((event.key === 'Delete' || event.key === 'Backspace') && this.selectedObject && !event.target.matches('input, textarea')) {
          event.preventDefault();
          this.deleteSelectedObject();
        }
      });
    }

    resetCanvas() {
      this.context.fillStyle = this.background;
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    }

    bindModes() {
      this.querySelectorAll('[data-mode]').forEach((button) => {
        button.addEventListener('click', () => {
          this.querySelectorAll('[data-mode]').forEach((item) => item.setAttribute('aria-selected', String(item === button)));
          this.querySelectorAll('[data-panel]').forEach((panel) => panel.hidden = panel.dataset.panel !== button.dataset.mode);
          this.method.value = button.dataset.mode === 'upload' ? 'Upload my design' : 'Create on canvas';
        });
      });
    }

    bindUpload() {
      this.upload.addEventListener('change', () => {
        const file = this.upload.files[0];
        if (!file) return;
        this.querySelector('[data-file-name]').textContent = file.name;
        this.hasArtwork = true;
        if (!file.type.startsWith('image/')) return;
        const image = new Image();
        image.onload = () => {
          this.saveState();
          this.resetCanvas();
          const scale = Math.min(this.canvas.width / image.width, this.canvas.height / image.height);
          const width = image.width * scale;
          const height = image.height * scale;
          this.context.drawImage(image, (this.canvas.width - width) / 2, (this.canvas.height - height) / 2, width, height);
          URL.revokeObjectURL(image.src);
        };
        image.src = URL.createObjectURL(file);
      });
    }

    bindCanvas() {
      const point = (event) => {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: (event.clientX - rect.left) * (this.canvas.width / rect.width),
          y: (event.clientY - rect.top) * (this.canvas.height / rect.height)
        };
      };
      this.canvas.addEventListener('pointerdown', (event) => {
        if (this.tool === 'select') {
          this.selectObject(null);
          return;
        }
        const start = point(event);
        if (this.tool === 'eyedropper') {
          const pixel = this.context.getImageData(Math.round(start.x), Math.round(start.y), 1, 1).data;
          this.querySelector('[data-brush-color]').value = `#${[pixel[0], pixel[1], pixel[2]].map((value) => value.toString(16).padStart(2, '0')).join('')}`;
          return;
        }
        this.saveState();
        this.drawing = true;
        this.hasArtwork = true;
        this.canvas.setPointerCapture(event.pointerId);
        this.shapeStart = start;
        this.shapeSnapshot = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        this.context.beginPath();
        this.context.moveTo(start.x, start.y);
      });
      this.canvas.addEventListener('pointermove', (event) => {
        if (!this.drawing) return;
        const current = point(event);
        const size = Number(this.querySelector('[data-brush-size]').value);
        const opacity = Number(this.querySelector('[data-opacity]').value) / 100;
        if (this.tool !== 'freehand') {
          this.drawShape(current, size, opacity);
          return;
        }
        const pressure = event.pressure > 0 ? event.pressure : .55;
        this.context.globalAlpha = this.brush === 'marker' ? Math.min(opacity, .35) : this.brush === 'watercolour' ? Math.min(opacity, .2) : this.brush === 'pencil' ? Math.min(opacity, .72) : opacity;
        this.context.strokeStyle = this.brush === 'eraser' ? this.background : this.querySelector('[data-brush-color]').value;
        this.context.lineWidth = this.brush === 'marker' ? size * 2.4 : this.brush === 'watercolour' ? size * 3.2 : this.brush === 'calligraphy' ? size * pressure * 2.2 : this.brush === 'pencil' ? Math.max(1, size * pressure * .6) : size * (.65 + pressure * .7);
        this.context.lineCap = this.brush === 'calligraphy' ? 'butt' : 'round';
        this.context.lineJoin = 'round';
        this.context.shadowBlur = this.brush === 'watercolour' ? size * .65 : 0;
        this.context.shadowColor = this.context.strokeStyle;
        if (this.brush === 'spray') {
          this.sprayAt(current, size, opacity);
        } else {
          this.context.beginPath();
          this.context.moveTo(this.shapeStart.x, this.shapeStart.y);
          this.context.lineTo(current.x, current.y);
          this.context.stroke();
          if (this.symmetry) {
            this.context.beginPath();
            this.context.moveTo(this.canvas.width - this.shapeStart.x, this.shapeStart.y);
            this.context.lineTo(this.canvas.width - current.x, current.y);
            this.context.stroke();
          }
        }
        this.shapeStart = current;
      });
      const finishStroke = () => {
        this.drawing = false;
        this.context.globalAlpha = 1;
        this.context.shadowBlur = 0;
      };
      this.canvas.addEventListener('pointerup', finishStroke);
      this.canvas.addEventListener('pointercancel', finishStroke);
    }

    bindTools() {
      this.querySelectorAll('[data-brush]').forEach((button) => {
        button.addEventListener('click', () => {
          this.brush = button.dataset.brush;
          this.querySelectorAll('[data-brush]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      this.querySelectorAll('[data-tool]').forEach((button) => {
        button.addEventListener('click', () => {
          this.tool = button.dataset.tool;
          this.querySelectorAll('[data-tool]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.objectLayer.classList.toggle('is-active', this.tool === 'select');
          this.canvas.style.cursor = this.tool === 'select' ? 'default' : this.tool === 'eyedropper' ? 'copy' : 'crosshair';
          if (this.tool !== 'select') this.selectObject(null);
        });
      });
      this.querySelectorAll('[data-colour]').forEach((button) => {
        button.addEventListener('click', () => {
          this.querySelector('[data-brush-color]').value = button.dataset.colour;
          this.querySelectorAll('[data-colour]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      this.querySelector('[data-brush-color]').addEventListener('input', () => {
        this.querySelectorAll('[data-colour]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      });
      this.querySelector('[data-brush-size]').addEventListener('input', (event) => {
        this.querySelector('[data-size-output]').value = event.target.value;
      });
      this.querySelector('[data-opacity]').addEventListener('input', (event) => {
        this.querySelector('[data-opacity-output]').value = `${event.target.value}%`;
      });
      this.querySelector('[data-symmetry]').addEventListener('click', (event) => {
        this.symmetry = !this.symmetry;
        event.currentTarget.setAttribute('aria-pressed', String(this.symmetry));
        this.querySelector('[data-symmetry-line]').hidden = !this.symmetry;
      });
      this.querySelector('[data-grid]').addEventListener('click', (event) => {
        const grid = this.querySelector('[data-grid-overlay]');
        grid.hidden = !grid.hidden;
        event.currentTarget.setAttribute('aria-pressed', String(!grid.hidden));
      });
      this.querySelector('[data-zoom]').addEventListener('input', (event) => {
        const zoom = Number(event.target.value);
        this.querySelector('[data-zoom-output]').value = `${zoom}%`;
        this.querySelector('[data-canvas-wrap]').style.width = `${zoom}%`;
      });
      this.querySelector('[data-place-image]').addEventListener('change', (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const image = new Image();
        image.onload = () => {
          this.saveState();
          const scale = Math.min(this.canvas.width * .72 / image.width, this.canvas.height * .72 / image.height);
          const width = image.width * scale;
          const height = image.height * scale;
          this.addImageObject(image.src, width / this.canvas.width * 100, height / this.canvas.height * 100);
          this.hasArtwork = true;
          this.activateSelectTool();
        };
        image.src = URL.createObjectURL(file);
        event.target.value = '';
      });
      this.querySelector('[data-download]').addEventListener('click', async () => {
        const link = document.createElement('a');
        link.download = 'azlyf-bespoke-design.png';
        link.href = (await this.compositeCanvas()).toDataURL('image/png');
        link.click();
      });
      this.querySelector('[data-object-delete]').addEventListener('click', () => this.deleteSelectedObject());
      this.querySelector('[data-object-forward]').addEventListener('click', () => {
        if (!this.selectedObject || !this.selectedObject.nextElementSibling) return;
        this.selectedObject.nextElementSibling.after(this.selectedObject);
        this.updateObjectActions();
      });
      this.querySelector('[data-object-back]').addEventListener('click', () => {
        if (!this.selectedObject || !this.selectedObject.previousElementSibling) return;
        this.selectedObject.previousElementSibling.before(this.selectedObject);
        this.updateObjectActions();
      });
      this.querySelector('[data-add-text]').addEventListener('click', () => {
        const input = this.querySelector('[data-canvas-text]');
        if (!input.value.trim()) return;
        this.saveState();
        this.context.fillStyle = this.querySelector('[data-brush-color]').value;
        this.context.globalAlpha = Number(this.querySelector('[data-opacity]').value) / 100;
        this.context.font = `64px ${this.querySelector('[data-font]').value}`;
        this.context.textAlign = 'center';
        this.context.textBaseline = 'middle';
        this.context.fillText(input.value.trim(), this.canvas.width / 2, this.canvas.height / 2, this.canvas.width * .78);
        this.context.globalAlpha = 1;
        this.hasArtwork = true;
        input.value = '';
      });
      this.querySelectorAll('[data-stamp]').forEach((button) => {
        button.addEventListener('click', () => this.addStamp(button.dataset.stamp));
      });
      this.querySelector('[data-fill]').addEventListener('click', () => {
        this.saveState();
        this.background = this.querySelector('[data-brush-color]').value;
        this.context.fillStyle = this.background;
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.hasArtwork = true;
      });
      this.querySelector('[data-undo]').addEventListener('click', () => {
        const previous = this.history.pop();
        if (!previous) return;
        this.future.push(this.context.getImageData(0, 0, this.canvas.width, this.canvas.height));
        this.context.putImageData(previous, 0, 0);
      });
      this.querySelector('[data-redo]').addEventListener('click', () => {
        const next = this.future.pop();
        if (!next) return;
        this.history.push(this.context.getImageData(0, 0, this.canvas.width, this.canvas.height));
        this.context.putImageData(next, 0, 0);
      });
      this.querySelector('[data-clear]').addEventListener('click', () => {
        this.saveState();
        this.resetCanvas();
        this.objectLayer.replaceChildren();
        this.selectedObject = null;
        this.hasArtwork = false;
      });
    }

    addStamp(shape) {
      const colour = this.querySelector('[data-brush-color]').value;
      const opacity = Number(this.querySelector('[data-opacity]').value) / 100;
      const paths = {
        circle: '<circle cx="50" cy="50" r="39" fill="none" stroke="currentColor" stroke-width="6"/>',
        flower: '<path d="M50 8C58 22 70 17 78 22C69 35 82 39 91 50C77 57 82 70 78 78C64 70 60 83 50 92C42 78 30 83 22 78C31 65 18 61 9 50C23 43 18 30 22 22C36 30 40 17 50 8Z" fill="currentColor"/>',
        star: '<path d="M50 7L60 37L92 37L66 56L76 88L50 69L24 88L34 56L8 37L40 37Z" fill="currentColor"/>'
      };
      this.addObject(`<svg viewBox="0 0 100 100" aria-hidden="true">${paths[shape]}</svg>`, 11, 28, { kind: 'stamp', shape, colour, opacity });
      this.hasArtwork = true;
      this.activateSelectTool();
    }

    activateSelectTool() {
      const button = this.querySelector('[data-tool="select"]');
      button.click();
    }

    addImageObject(src, width, height) {
      this.addObject(`<img src="${src}" alt="Uploaded artwork">`, width, height, { kind: 'image' });
    }

    addObject(markup, width, height, metadata) {
      const object = document.createElement('div');
      object.className = 'bespoke-studio__object';
      object.style.width = `${width}%`;
      object.style.height = `${height}%`;
      object.style.color = metadata.colour || 'currentColor';
      object.style.opacity = metadata.opacity ?? 1;
      Object.entries(metadata).forEach(([key, value]) => object.dataset[key] = value);
      object.innerHTML = `${markup}<span class="bespoke-studio__resize-handle" aria-label="Resize object"></span>`;
      this.objectLayer.appendChild(object);
      this.bindObject(object);
      this.selectObject(object);
    }

    bindObject(object) {
      object.addEventListener('pointerdown', (event) => {
        if (this.tool !== 'select') return;
        event.preventDefault();
        event.stopPropagation();
        this.selectObject(object);
        const layerRect = this.objectLayer.getBoundingClientRect();
        const startX = event.clientX;
        const startY = event.clientY;
        const startLeft = object.offsetLeft;
        const startTop = object.offsetTop;
        const startWidth = object.offsetWidth;
        const startHeight = object.offsetHeight;
        const resizing = event.target.classList.contains('bespoke-studio__resize-handle');
        object.setPointerCapture(event.pointerId);
        const move = (moveEvent) => {
          const dx = moveEvent.clientX - startX;
          const dy = moveEvent.clientY - startY;
          if (resizing) {
            const ratio = startWidth / startHeight;
            const nextWidth = Math.max(36, startWidth + dx);
            object.style.width = `${nextWidth / layerRect.width * 100}%`;
            object.style.height = `${nextWidth / ratio / layerRect.height * 100}%`;
          } else {
            object.style.left = `${Math.max(0, Math.min(layerRect.width, startLeft + dx)) / layerRect.width * 100}%`;
            object.style.top = `${Math.max(0, Math.min(layerRect.height, startTop + dy)) / layerRect.height * 100}%`;
          }
        };
        const end = () => {
          object.removeEventListener('pointermove', move);
          object.removeEventListener('pointerup', end);
          object.removeEventListener('pointercancel', end);
        };
        object.addEventListener('pointermove', move);
        object.addEventListener('pointerup', end);
        object.addEventListener('pointercancel', end);
      });
    }

    selectObject(object) {
      this.selectedObject = object;
      this.querySelectorAll('.bespoke-studio__object').forEach((item) => item.classList.toggle('is-selected', item === object));
      this.updateObjectActions();
    }

    updateObjectActions() {
      const selected = this.selectedObject;
      this.querySelector('[data-object-delete]').disabled = !selected;
      this.querySelector('[data-object-forward]').disabled = !selected || !selected.nextElementSibling;
      this.querySelector('[data-object-back]').disabled = !selected || !selected.previousElementSibling;
    }

    deleteSelectedObject() {
      if (!this.selectedObject) return;
      this.selectedObject.remove();
      this.selectedObject = null;
      this.updateObjectActions();
      this.hasArtwork = this.objectLayer.children.length > 0 || this.canvasHasMarks();
    }

    canvasHasMarks() {
      const pixels = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height).data;
      const background = this.context.getImageData(0, 0, 1, 1).data;
      for (let index = 0; index < pixels.length; index += 64) {
        if (pixels[index] !== background[0] || pixels[index + 1] !== background[1] || pixels[index + 2] !== background[2]) return true;
      }
      return false;
    }

    async compositeCanvas() {
      const output = document.createElement('canvas');
      output.width = this.canvas.width;
      output.height = this.canvas.height;
      const context = output.getContext('2d');
      context.drawImage(this.canvas, 0, 0);
      for (const object of this.querySelectorAll('.bespoke-studio__object')) {
        const width = parseFloat(object.style.width) / 100 * output.width;
        const height = parseFloat(object.style.height) / 100 * output.height;
        const x = parseFloat(object.style.left) / 100 * output.width - width / 2;
        const y = parseFloat(object.style.top) / 100 * output.height - height / 2;
        context.save();
        context.globalAlpha = Number(object.style.opacity || 1);
        if (object.dataset.kind === 'image') {
          const image = object.querySelector('img');
          if (!image.complete) await image.decode();
          context.drawImage(image, x, y, width, height);
        } else {
          context.fillStyle = object.dataset.colour;
          context.strokeStyle = object.dataset.colour;
          context.lineWidth = Math.max(3, width * .06);
          context.beginPath();
          if (object.dataset.shape === 'circle') {
            context.arc(x + width / 2, y + height / 2, Math.min(width, height) * .39, 0, Math.PI * 2);
            context.stroke();
          } else {
            const points = object.dataset.shape === 'flower' ? 12 : 10;
            for (let index = 0; index < points; index += 1) {
              const outer = index % 2 === 0;
              const radius = Math.min(width, height) * (outer ? .46 : object.dataset.shape === 'flower' ? .2 : .21);
              const angle = -Math.PI / 2 + index * Math.PI * 2 / points;
              const px = x + width / 2 + Math.cos(angle) * radius;
              const py = y + height / 2 + Math.sin(angle) * radius;
              if (index === 0) context.moveTo(px, py); else context.lineTo(px, py);
            }
            context.closePath();
            context.fill();
          }
        }
        context.restore();
      }
      return output;
    }

    sprayAt(point, size, opacity) {
      this.context.save();
      this.context.globalAlpha = Math.min(opacity, .5);
      this.context.fillStyle = this.querySelector('[data-brush-color]').value;
      const radius = size * 2.8;
      for (let index = 0; index < 34; index += 1) {
        const angle = Math.random() * Math.PI * 2;
        const distance = Math.sqrt(Math.random()) * radius;
        const x = point.x + Math.cos(angle) * distance;
        const y = point.y + Math.sin(angle) * distance;
        this.context.fillRect(x, y, Math.max(1, size * .09), Math.max(1, size * .09));
        if (this.symmetry) this.context.fillRect(this.canvas.width - x, y, Math.max(1, size * .09), Math.max(1, size * .09));
      }
      this.context.restore();
    }

    drawShape(current, size, opacity) {
      if (!this.shapeSnapshot || !this.shapeStart) return;
      this.context.putImageData(this.shapeSnapshot, 0, 0);
      this.context.save();
      this.context.globalAlpha = opacity;
      this.context.strokeStyle = this.querySelector('[data-brush-color]').value;
      this.context.lineWidth = size;
      this.context.lineCap = 'round';
      const start = this.shapeStart;
      this.context.beginPath();
      if (this.tool === 'line') {
        this.context.moveTo(start.x, start.y);
        this.context.lineTo(current.x, current.y);
      } else if (this.tool === 'rectangle') {
        this.context.rect(start.x, start.y, current.x - start.x, current.y - start.y);
      } else if (this.tool === 'ellipse') {
        this.context.ellipse((start.x + current.x) / 2, (start.y + current.y) / 2, Math.abs(current.x - start.x) / 2, Math.abs(current.y - start.y) / 2, 0, 0, Math.PI * 2);
      }
      this.context.stroke();
      this.context.restore();
    }

    saveState() {
      this.history.push(this.context.getImageData(0, 0, this.canvas.width, this.canvas.height));
      if (this.history.length > 40) this.history.shift();
      this.future = [];
    }

    async prepareOrder(event) {
      if (!this.upload.files.length && !this.hasArtwork) {
        event.preventDefault();
        this.error.hidden = false;
        this.querySelector('.bespoke-studio__workspace').scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      this.error.hidden = true;
      if (!this.hasArtwork || this.method.value === 'Upload my design') return;
      event.preventDefault();
      const output = await this.compositeCanvas();
      output.toBlob((blob) => {
        const transfer = new DataTransfer();
        transfer.items.add(new File([blob], 'azlyf-bespoke-design.png', { type: 'image/png' }));
        this.canvasFile.files = transfer.files;
        event.target.submit();
      }, 'image/png');
    }
  }
  if (!customElements.get('azlyf-bespoke-studio')) customElements.define('azlyf-bespoke-studio', AzlyfBespokeStudio);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azlyf-complete-my-look"] && !Shopify.designMode) return;
  try {
    
  class AzlyfCompleteMyLook extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.input = this.querySelector('[data-image-input]');
      this.dropZone = this.querySelector('[data-drop-zone]');
      this.uploadPanel = this.querySelector('[data-upload-panel]');
      this.canvasPanel = this.querySelector('[data-canvas-panel]');
      this.canvas = this.querySelector('[data-outfit-canvas]');
      this.context = this.canvas.getContext('2d', { willReadFrequently: true });
      this.results = this.querySelector('[data-look-results]');
      this.recommendations = this.querySelector('[data-recommendations]');
      this.sampleSwatch = this.querySelector('[data-sample-swatch]');
      this.catalog = JSON.parse(this.querySelector('[data-look-catalog]').textContent).map((shade) => ({ ...shade, rgb: this.hexToRgb(shade.color) }));
      this.input.addEventListener('change', () => this.loadFile(this.input.files[0]));
      this.querySelector('[data-replace-image]').addEventListener('click', () => this.reset());
      this.canvas.addEventListener('click', (event) => this.samplePoint(event));
      ['dragenter', 'dragover'].forEach((name) => this.dropZone.addEventListener(name, (event) => { event.preventDefault(); this.dropZone.classList.add('is-dragging'); }));
      ['dragleave', 'drop'].forEach((name) => this.dropZone.addEventListener(name, (event) => { event.preventDefault(); this.dropZone.classList.remove('is-dragging'); }));
      this.dropZone.addEventListener('drop', (event) => this.loadFile(event.dataTransfer.files[0]));
    }

    loadFile(file) {
      if (!file || !file.type.startsWith('image/')) return;
      const reader = new FileReader();
      reader.onload = () => {
        const image = new Image();
        image.onload = () => this.drawImage(image);
        image.src = reader.result;
      };
      reader.readAsDataURL(file);
    }

    drawImage(image) {
      const max = 900;
      const scale = Math.min(1, max / Math.max(image.width, image.height));
      this.canvas.width = Math.round(image.width * scale);
      this.canvas.height = Math.round(image.height * scale);
      this.context.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
      this.uploadPanel.hidden = true;
      this.canvasPanel.hidden = false;
      this.results.hidden = false;
      this.renderMatches(this.dominantColour());
    }

    dominantColour() {
      const data = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height).data;
      const buckets = new Map();
      const stride = Math.max(4, Math.floor(data.length / 60000 / 4) * 4);
      for (let index = 0; index < data.length; index += stride) {
        const r = data[index], g = data[index + 1], b = data[index + 2], a = data[index + 3];
        const brightness = (r + g + b) / 3;
        if (a < 200 || brightness > 242 || brightness < 12) continue;
        const key = `${Math.round(r / 32) * 32},${Math.round(g / 32) * 32},${Math.round(b / 32) * 32}`;
        buckets.set(key, (buckets.get(key) || 0) + 1);
      }
      const winner = [...buckets].sort((a, b) => b[1] - a[1])[0]?.[0] || '128,128,128';
      return winner.split(',').map(Number);
    }

    samplePoint(event) {
      const rect = this.canvas.getBoundingClientRect();
      const x = Math.max(0, Math.min(this.canvas.width - 1, Math.round((event.clientX - rect.left) * this.canvas.width / rect.width)));
      const y = Math.max(0, Math.min(this.canvas.height - 1, Math.round((event.clientY - rect.top) * this.canvas.height / rect.height)));
      const radius = 4;
      const pixel = this.context.getImageData(Math.max(0, x - radius), Math.max(0, y - radius), Math.min(radius * 2 + 1, this.canvas.width - x + radius), Math.min(radius * 2 + 1, this.canvas.height - y + radius)).data;
      const colour = [0, 0, 0];
      let count = 0;
      for (let index = 0; index < pixel.length; index += 4) {
        if (pixel[index + 3] < 200) continue;
        colour[0] += pixel[index]; colour[1] += pixel[index + 1]; colour[2] += pixel[index + 2]; count++;
      }
      this.renderMatches(colour.map((channel) => Math.round(channel / Math.max(1, count))));
    }

    renderMatches(rgb) {
      const tonal = [...this.catalog].sort((a, b) => this.distance(a.rgb, rgb) - this.distance(b.rgb, rgb))[0];
      const brightness = (rgb[0] + rgb[1] + rgb[2]) / 3;
      const neutralName = brightness < 105 ? 'Morning Mist' : brightness > 205 ? 'Classic Black' : 'Sepia Brown';
      const neutral = this.catalog.find((shade) => shade.name === neutralName);
      const contrast = [...this.catalog].filter((shade) => shade.name !== tonal.name && shade.name !== neutral.name).sort((a, b) => this.contrastScore(b.rgb, rgb) - this.contrastScore(a.rgb, rgb))[0];
      const picks = [
        { ...tonal, role: 'Tonal harmony', copy: 'Echoes your outfit for a composed, monochromatic finish.' },
        { ...neutral, role: 'Elegant neutral', copy: 'Balances the look with an effortless wardrobe anchor.' },
        { ...contrast, role: 'Considered contrast', copy: 'Adds definition while keeping the palette intentional.' }
      ];
      this.sampleSwatch.style.backgroundColor = `rgb(${rgb.join(',')})`;
      this.recommendations.replaceChildren(...picks.map((pick) => this.createCard(pick)));
    }

    createCard(pick) {
      const link = document.createElement('a');
      link.className = 'look-matcher__card';
      link.href = `/products/${pick.handle}`;
      link.innerHTML = `<span class="look-matcher__card-swatch" style="--match-color:${pick.color}"></span><span class="look-matcher__card-copy"><small>${pick.role}</small><strong>${pick.name}</strong><span>${pick.copy}</span></span><span class="look-matcher__card-arrow" aria-hidden="true">↗</span>`;
      return link;
    }

    distance(a, b) { return Math.sqrt(a.reduce((sum, value, index) => sum + ((value - b[index]) ** 2), 0)); }
    contrastScore(a, b) {
      const distance = this.distance(a, b);
      const brightnessDifference = Math.abs((a[0] + a[1] + a[2]) - (b[0] + b[1] + b[2]));
      return distance + brightnessDifference * .2;
    }
    hexToRgb(hex) { return [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)]; }
    reset() {
      this.input.value = '';
      this.uploadPanel.hidden = false;
      this.canvasPanel.hidden = true;
      this.results.hidden = true;
    }
  }
  if (!customElements.get('azlyf-complete-my-look')) customElements.define('azlyf-complete-my-look', AzlyfCompleteMyLook);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azlyf-shade-assistant"] && !Shopify.designMode) return;
  try {
    
  class AzlyfShadeAssistant extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.step = 0;
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.form = this.querySelector('.shade-assistant__form');
      this.results = this.querySelector('.shade-assistant__results');
      this.matches = this.querySelector('.shade-assistant__matches');
      this.next = this.querySelector('[data-next]');
      this.back = this.querySelector('[data-back]');
      this.error = this.querySelector('[data-error]');
      this.progressLabel = this.querySelector('[data-progress-label]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.profileName = this.querySelector('[data-profile-name]');
      this.profileIntro = this.querySelector('[data-profile-intro]');
      this.profileTraits = this.querySelector('[data-profile-traits]');
      this.saveButton = this.querySelector('[data-save-profile]');
      this.shareButton = this.querySelector('[data-share-profile]');
      this.saveNote = this.querySelector('[data-save-note]');
      this.catalog = JSON.parse(this.querySelector('[data-shade-catalog]').textContent);
      this.storageKey = 'azlyf-colour-id-v1';
      this.labels = {
        progress: this.progressLabel.textContent,
        continue: this.next.textContent,
        reveal: this.dataset.revealLabel,
        reason: this.dataset.reasonLabel
      };
      this.next.addEventListener('click', () => this.advance());
      this.back.addEventListener('click', () => this.showStep(this.step - 1));
      this.querySelector('.shade-assistant__restart').addEventListener('click', () => this.restart());
      this.saveButton.addEventListener('click', () => this.saveProfile());
      this.shareButton.addEventListener('click', () => this.shareProfile());
      this.restoreProfile();
    }

    advance() {
      const selected = this.steps[this.step].querySelector('input:checked');
      if (!selected) {
        this.error.hidden = false;
        this.steps[this.step].querySelector('input').focus();
        return;
      }
      this.error.hidden = true;
      if (this.step < this.steps.length - 1) this.showStep(this.step + 1);
      else this.showResults();
    }

    showStep(index) {
      this.steps[this.step].hidden = true;
      this.step = index;
      this.steps[this.step].hidden = false;
      this.back.hidden = this.step === 0;
      this.next.textContent = this.step === this.steps.length - 1 ? this.labels.reveal : this.labels.continue;
      this.progressLabel.textContent = this.labels.progress.replace('1', this.step + 1);
      this.progressBar.style.transform = `scaleX(${(this.step + 1) / this.steps.length})`;
      this.steps[this.step].querySelector('legend').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    showResults() {
      const answers = new FormData(this.form);
      const selected = [answers.get('undertone'), answers.get('wardrobe'), answers.get('mood')];
      const ranked = this.catalog
        .map((shade) => ({ ...shade, score: selected.filter((answer) => shade.tags.includes(answer)).length }))
        .sort((a, b) => b.score - a.score || a.name.localeCompare(b.name))
        .slice(0, 3);
      const profile = this.buildProfile(selected, ranked);
      this.currentProfile = profile;
      this.renderProfile(profile);
      this.matches.replaceChildren(...ranked.map((shade, index) => this.createMatch(shade, index)));
      this.form.hidden = true;
      this.results.hidden = false;
      this.results.querySelector('h3').focus();
    }

    createMatch(shade, index) {
      const link = document.createElement('a');
      link.className = 'shade-assistant__match';
      link.href = `/products/${shade.handle}`;
      const score = Math.max(82, 98 - (index * 6));
      link.innerHTML = `<span class="shade-assistant__swatch" style="--shade-color:${shade.color}"></span><span class="shade-assistant__match-copy"><span class="shade-assistant__match-name">${shade.name}<span aria-hidden="true">↗</span></span><span class="shade-assistant__match-reason">${this.labels.reason.replace('[number]', index + 1)}</span><span class="shade-assistant__match-score" style="--shade-color:${shade.color}">${score}% Colour ID match</span></span>`;
      return link;
    }

    buildProfile(selected, ranked) {
      const [undertone, wardrobe, mood] = selected;
      const names = {
        warm: { soft: 'Sunlit Soft', statement: 'Golden Statement', polished: 'Warmly Refined', everyday: 'Golden Everyday' },
        cool: { soft: 'Silver Soft', statement: 'Cool Contrast', polished: 'Quietly Refined', everyday: 'Cool Everyday' },
        neutral: { soft: 'Balanced Soft', statement: 'Modern Contrast', polished: 'Balanced Refined', everyday: 'Modern Neutral' },
        unsure: { soft: 'Versatile Soft', statement: 'Confident Contrast', polished: 'Effortless Refined', everyday: 'Everyday Ease' }
      };
      const descriptions = {
        warm: 'Warm, grounded colour brings an effortless glow to your palette.',
        cool: 'Cool, clear colour creates harmony and definition around your complexion.',
        neutral: 'Balanced colour gives you the freedom to move between warm and cool palettes.',
        unsure: 'Versatile, complexion-friendly colour gives you an easy place to begin.'
      };
      const labels = {
        warm: 'Warm leaning', cool: 'Cool leaning', neutral: 'Balanced undertone', unsure: 'Versatile undertone',
        neutrals: 'Neutral wardrobe', earthy: 'Earthy wardrobe', colourful: 'Colour-led wardrobe',
        everyday: 'Everyday ease', soft: 'Soft mood', polished: 'Polished mood', statement: 'Statement mood'
      };
      return {
        name: names[undertone][mood],
        intro: descriptions[undertone],
        answers: selected,
        traits: [labels[undertone], labels[wardrobe] || wardrobe, labels[mood]],
        matches: ranked.map(({ name, handle, color, score }) => ({ name, handle, color, score }))
      };
    }

    renderProfile(profile) {
      this.profileName.textContent = profile.name;
      this.profileIntro.textContent = profile.intro;
      this.profileTraits.replaceChildren(...profile.traits.map((trait) => {
        const span = document.createElement('span');
        span.className = 'shade-assistant__trait';
        span.textContent = trait;
        return span;
      }));
      this.saveButton.textContent = 'Save my Colour ID';
      this.saveNote.hidden = true;
    }

    saveProfile() {
      if (!this.currentProfile) return;
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(this.currentProfile));
        this.saveButton.textContent = 'Colour ID saved';
        this.saveNote.hidden = false;
      } catch (error) {
        this.saveNote.textContent = 'Your browser prevented saving. You can still screenshot or share your result.';
        this.saveNote.hidden = false;
      }
    }

    restoreProfile() {
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if (!saved?.matches?.length) return;
        this.currentProfile = saved;
        this.renderProfile(saved);
        this.matches.replaceChildren(...saved.matches.map((shade, index) => this.createMatch(shade, index)));
        this.form.hidden = true;
        this.results.hidden = false;
        this.saveButton.textContent = 'Colour ID saved';
        this.saveNote.hidden = false;
      } catch (error) {
        localStorage.removeItem(this.storageKey);
      }
    }

    async shareProfile() {
      if (!this.currentProfile) return;
      const shades = this.currentProfile.matches.map((shade) => shade.name).join(', ');
      const text = `My Azlyf Colour ID is ${this.currentProfile.name}. My shades: ${shades}.`;
      if (navigator.share) {
        try { await navigator.share({ title: 'My Azlyf Colour ID', text, url: window.location.href }); } catch (error) { return; }
      } else {
        await navigator.clipboard.writeText(`${text} ${window.location.href}`);
        this.shareButton.textContent = 'Result copied';
      }
    }

    restart() {
      this.form.reset();
      this.currentProfile = null;
      this.results.hidden = true;
      this.form.hidden = false;
      this.showStep(0);
      this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  if (!customElements.get('azlyf-shade-assistant')) customElements.define('azlyf-shade-assistant', AzlyfShadeAssistant);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
